// extracted by mini-css-extract-plugin
module.exports = {"wrap":"formWrapResponse_wrap__1f2YQ","show":"formWrapResponse_show__3Heov"};